module.exports = __webpack_public_path__ + "fonts/iconfont.76ddabd0.ttf";